import { Component, computed, inject, input } from '@angular/core';
import { PageTitle } from '../../../layout/components/page-title/page-title';
import { PageHeader } from '../../../layout/components/page-header/page-header';
import { OrganizationSidebarLayout } from '../../../organizations/components/organization-sidebar-layout/organization-sidebar-layout';
import { Button, Skeleton } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { LocationDetailsBreadcrumbNav } from '../../components/location-details-breadcrumb-nav/location-details-breadcrumb-nav';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { LocationDetailsNav } from '../../components/location-details-nav/location-details-nav';
import { LocationsStore } from '../../store/locations.store';
import { ErrorPage } from '../../../../shared/components/error-page/error-page';
import { NavSkeleton } from '../../../../shared/components/nav-skeleton/nav-skeleton';
import { LocationNamePipe } from '../../pipes/location-name-pipe';

@Component({
  selector: 'app-location-details-page',
  imports: [
    RouterLink,
    PageTitle,
    PageHeader,
    OrganizationSidebarLayout,
    Button,
    NgIcon,
    LocationDetailsBreadcrumbNav,
    RouterOutlet,
    LocationDetailsNav,
    ErrorPage,
    NavSkeleton,
    LocationNamePipe,
    Skeleton,
  ],
  templateUrl: './location-details-page.html',
})
export class LocationDetailsPage {
  private store = inject(LocationsStore);
  protected router = inject(Router);

  organizationId = input.required<string>();
  locationId = input.required<string>();

  protected state = computed(() =>
    this.store.locations()?.find((loc) => loc.id === this.locationId()),
  );
}
